import React, { Component } from "react";
import { processProduct } from "@views/product-list/helpers/product";
import Product from "@views/product-list/components/product";
import Loader from "@components/loader";
import Button from "@components/button";
import { getRecommendByCityId } from "./store";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingStatus: "done",
      cityId: props.cityId,
      products: props.products,
    };

    // hotCity 变更的话更改一下这个 component 的 key
    this.hotCitiesMapById = (props.hotCities || []).reduce((map, city) => {
      map[city.cityId] = city; // eslint-disable-line
      return map;
    }, {});
  }

  render() {
    const { cityId } = this.state;
    const { url, cityName } = this.hotCitiesMapById[cityId] || {};

    return (
      <div className="recommend-block" data-city={cityName}>
        {this.renderHotCities()}
        {this.renderRecommendations()}
        <p className="more-actioins">
          <a href={url} className="btn btn-primary">
            更多{cityName}民宿
          </a>
        </p>
      </div>
    );
  }

  renderRecommendations() {
    const { loadingStatus, error, products } = this.state;
    return loadingStatus === "error" ? (
      <p className="error-notice">
        {error.message}
        <Button btnType="warning" onClick={() => this.query()}>
          重试
        </Button>
      </p>
    ) : (
      <ul className="product-grid ecols ecols-sm-6 ecols-md-4 list-unstyled">
        {products.map((item, index) => {
          let product = processProduct(item);
          return (
            <li className="product-grid__item ecol" key={item.productId} data-index={index}>
              <Product product={product} showFavButton={false} />
            </li>
          );
        })}
      </ul>
    );
  }

  renderHotCities() {
    const hotCities = this.props.hotCities;
    const { cityId, loadingStatus } = this.state;
    if (!hotCities || !hotCities.length) return null;
    const cities = hotCities.map(({ cityId: id, cityName: name, adDeliveryId: adId }, k) => (
      <li
        key={k}
        className={`hot-city${+cityId === id ? " current" : ""}`}
        data-ad-id={adId}
        onClick={() => this.changeHotCity(id)}
      >
        {name}
        {cityId === id && loadingStatus === "loading" ? <Loader active /> : null}
      </li>
    ));
    return (
      <ul className="hot-cities">
        {cities}
        {!this.props.showHostGuide || (
          <li className="hot-city">
            <a href="#host-guide">榛果课堂</a>
          </li>
        )}
      </ul>
    );
  }

  changeHotCity(cityId) {
    this.setState({ cityId });
    this.query(cityId);
  }

  query(cityId = this.state.cityId) {
    // 加个loading
    this.setState({ loadingStatus: "loading" });
    getRecommendByCityId(cityId).then(
      products => {
        this.setState({ products, loadingStatus: "done", error: null });
      },
      error => {
        this.setState({ loadingStatus: "error", error: { message: error.message }, products: [] });
      }
    );
  }
}

export default List;

require("./index.less");
require("./index.less");